<template>
	<div class="left_option">
		<em class="lt_text">{{ name }}</em>
		<span class="int_type half_int">
			<!-- <autocomplete ref="ac" :source="list" @selected="selectClass" :results-display="formattedDisplay" placeholder="Select Partner Name" /> -->
			<autocomplete ref="ac" :source="selectPartners" @selected="selectClass" :results-display="formattedDisplay" placeholder="Select Partner Name" />
		</span>
		<span class="int_type_no_border mgr_5">
			<input type="text" class="tbl_int" v-model.trim="code_string" autocomplete="off" style="width:300px;" @input="update" />
		</span>
	</div>
</template>
<script>
import { apiSelectSimplePartnerList } from '@/api/partner';

export default {
	name: 'SelectPartners',
	props: {
		customerOnly: {
			type: Boolean,
			default: true,
		},
		vendorOnly: {
			type: Boolean,
			default: false,
		},
		delim: {
			type: String,
			default: ',',
		},
		name: {
			type: String,
			default: 'Partners',
		},
	},
	data: function() {
		return {
			code_string: null,
			list: [],
		};
	},
	computed: {
		user: function() {
			return this.$session.get('user');
		},
	},
	methods: {
		selectPartners(input) {
			var url = process.env.VUE_APP_API_URL + '/api/partner/acPartnerList?company_id=' + this.user.company_id + '&keyword=' + input;
			if (this.customerOnly) url += '&customer_only=true';
			if (this.vendorOnly) url += '&vendor_only=true';

			return url;
		},
		async apiSelectData() {
			//이건 사용하지 않는게 좋음, 초기 화면 로딩이 오래 걸림
			const param = {
				paging_yn: 'N',
				sort_key: 'name',
				active_yn: 'Y',
			};

			if (this.customerOnly) param.customer_only = true;
			if (this.vendorOnly) param.vendor_only = true;

			const { data } = await apiSelectSimplePartnerList(param);
			this.list = data.partnerList;
		},
		selectClass(c) {
			this.$refs.ac.clear();
			if (this.code_string) this.code_string += this.delim + c.selectedObject.code;
			else this.code_string = c.selectedObject.code;
			this.update();
		},
		reset() {
			this.code_string = null;
			this.update();
		},
		update() {
			this.$emit('input', this.code_string);
		},
		formattedDisplay(result) {
			return (
				result.code.split('-').reduce(function(t, s) {
					return t + s;
				}) +
				' / ' +
				result.code +
				' / ' +
				result.name
			);
		},
	},
	mounted() {
		//this.apiSelectData();
	},
};
</script>
